
      var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWifi = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 121,
  height: 120,
  viewBox: "0 0 121 120",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 61,
  cy: 87.5,
  r: 4.5,
  fill: "var(--theme-primary, #810ea9)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M75.77 74.234a21.746 21.746 0 0 0-15.135-6.103A21.746 21.746 0 0 0 45.5 74.234m44.781-13.567C82.421 53.424 71.922 49 60.391 49 48.859 49 38.36 53.424 30.5 60.667m74-14.179c-11.623-10.559-27.06-16.994-44-16.994s-32.377 6.435-44 16.994",
  stroke: "#000",
  strokeWidth: 4.267,
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M61 87.5 106.5 47",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 4.4,
  strokeLinecap: "round"
})));

      const __svgRaw = "<svg width=\"121\" height=\"120\" viewBox=\"0 0 121 120\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <circle cx=\"61\" cy=\"87.5\" r=\"4.5\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n    <path d=\"M75.77 74.234a21.746 21.746 0 0 0-15.135-6.103A21.746 21.746 0 0 0 45.5 74.234M90.281 60.667C82.421 53.424 71.922 49 60.391 49 48.859 49 38.36 53.424 30.5 60.667M104.5 46.488c-11.623-10.559-27.06-16.994-44-16.994s-32.377 6.435-44 16.994\" stroke=\"#000\" stroke-width=\"4.267\" stroke-linecap=\"round\"/>\r\n    <path d=\"M61 87.5 106.5 47\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"4.4\" stroke-linecap=\"round\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/wifi.b214c7e0ad5e0c29b8645a32852e27e4.svg"),
        {
          React: SvgWifi,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      